import request from '@/utils/request'
import URL from '@/api/urlTranslator'

// 判断job里是否存在费用已经关账
export function isContainClosedCharge(params) {
  return request({
    url: URL.act.isContainClosedCharge,
    method: 'get',
    params
  })
}

// 查询当前分公司最近一次关帐记录
export function queryCurrentOfficeClosingAccount(params) {
  return request({
    url: URL.act.queryCurrentOfficeClosingAccount,
    method: 'get',
    params
  })
}

// 查询总部所有关帐记录
export function queryCurrentTenantClosingAccount(params) {
  return request({
    url: URL.act.queryCurrentTenantClosingAccount,
    method: 'get',
    params
  })
}

// 检查上个月是否已经关过帐
export function checkAccountClosed(params) {
  return request({
    url: URL.act.checkAccountClosed,
    method: 'get',
    params
  })
}

// 保存关账记录
export function saveClosingAccount(data) {
  return request({
    url: URL.act.saveClosingAccount,
    method: 'post',
    data
  })
}

// 批量保存关账记录
export function batchSaveClosingAccount(data) {
  return request({
    url: URL.act.batchSaveClosingAccount,
    method: 'post',
    data
  })
}

// 删除关账记录
export function deleteClosingAccount(params) {
  return request({
    url: URL.act.deleteClosingAccount,
    method: 'delete',
    params
  })
}

// 判断业务是否关账
export function checkJobOfClosingAccount(params) {
  return request({
    url: URL.act.closingAccount.checkJobOfClosingAccount,
    method: 'get',
    params
  })
}

// 获取当前租户关账记录的所有年份
export function queryAllClosingAccountYear() {
  return request({
    url: URL.act.closingAccount.queryAllClosingAccountYear,
    method: 'get'
  })
}
